// src/redux/slices/modifiersSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ModifierOption {
  id: string;
  restaurantId: string;
  name: string;
  price: string;
  image: string | null;
  isEnabled: boolean;
  childGroupId: string | null;
  posReferenceId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ModifierGroup {
  id: string;
  restaurantId: string;
  posReferenceId: string;
  name: string;
  modifierType: string | null;
  isRequired: boolean;
  allowMultiples: boolean;
  minRequired: number;
  maxAllowed: number;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

interface ModifiersState {
  groups: ModifierGroup[];
  options: ModifierOption[];
  loading: boolean;
  error: string | null;
}

const initialState: ModifiersState = {
  groups: [],
  options: [],
  loading: false,
  error: null,
};

const modifiersSlice = createSlice({
  name: 'modifiers',
  initialState,
  reducers: {
    fetchModifiersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchModifiersSuccess: (
      state,
      action: PayloadAction<{ groups: ModifierGroup[]; options: ModifierOption[] }>
    ) => {
      state.loading = false;
      state.groups = action.payload.groups;
      state.options = action.payload.options;
      state.error = null;
    },
    fetchModifiersFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchModifiersRequest,
  fetchModifiersSuccess,
  fetchModifiersFailure,
} = modifiersSlice.actions;

export default modifiersSlice.reducer;
